import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { PlaybookNodeData } from '../store/usePlaybookStore'; // Assuming common data structure

// Basic styling (can be enhanced later)
const nodeStyle: React.CSSProperties = {
  padding: '10px 15px',
  border: '1px solid #6a0dad', // Purple border for inject
  borderRadius: '5px',
  background: '#f0e6ff', // Light purple background
  fontSize: '12px',
  textAlign: 'center',
  minWidth: '120px',
};

const InjectNode: React.FC<NodeProps<PlaybookNodeData>> = ({ data }) => {
  return (
    <div style={nodeStyle}>
      {/* Input Handle (Top) - Typically inject nodes don't have inputs in playbooks */}
      {/* <Handle type="target" position={Position.Top} id="input" /> */}

      <div>
        <strong>Inject</strong>
        {data.label && <div>({data.label})</div>}
        {/* Display other relevant data if needed */}
      </div>

      {/* Output Handle (Bottom) */}
      <Handle type="source" position={Position.Bottom} id="output" />
    </div>
  );
};

export default memo(InjectNode);
